import { SearchQueryRequestType } from '../../common/types';
import { usePostFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';

import { CandidateType } from './Candidates.types';

export type FetchUsersResponseType = {
  count: number;
  results: CandidateType[];
};

export const useSearchCandidates = (payload?: SearchQueryRequestType) => {
  const url = payload ? pathToUrl(ApiRoutesEnum.searchCandidates) : '';
  return usePostFetch<FetchUsersResponseType>(url, payload);
};
